import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import type SipCall from '@/data/models/domain/SipCall'
import { sipCallsRepoSettings } from '@/data/repositories/domain/types'
import SmsRepository from '@/data/repositories/domain/smsRepository'
import type { PaginationUrlFilterType } from '@/services/tables/types'

@RepoSettings<Endpoint>(sipCallsRepoSettings)
@injectable()
@injectFromBase()
export default class SipCallsRepository<T extends SipCall = SipCall> extends SmsRepository<T> {
  protected override decorateFilterToStrictQueryPart(queryParts: PaginationUrlFilterType) {
    return this.filterQueryService.serializeFiltersToBracketNotation({ filters: queryParts })
  }
}
